module.exports = __webpack_public_path__ + "static/09-d269c5cddf3f512e4d1cad44084f8600.png";